<div class="w-full flex gap-1 px-1 bg-k-gray-disabled h-1">

    <div *ngFor="let s of segment;" [class]="'flex-1 bar ' + s"></div>
</div>